import React, { useState } from 'react'
import { Card, CardContent, CardHeader, Button } from '../components/ui'
import { useI18n } from '../i18n'
import { useAuth } from '../components/AuthProvider'
import { API_ENDPOINTS } from '../config/api'
import { Send, Upload } from 'lucide-react'
import { pageScope } from '../lib/cssScope'

const Help: React.FC = () => {
  const { t } = useI18n()
  const { token } = useAuth()
  const [helpText, setHelpText] = useState('')
  const [helpFile, setHelpFile] = useState<File | null>(null)
  const [loading, setLoading] = useState(false)

  const submitHelpRequest = async () => {
    try {
      setLoading(true)
      const fd = new FormData()
      fd.append('message', helpText)
      if (helpFile) fd.append('file', helpFile)
      const res = await fetch(API_ENDPOINTS.HELP_REQUEST, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: fd
      })
      if (res.ok) {
        setHelpText('')
        setHelpFile(null)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={`${pageScope('help')} p-6 space-y-6`}>
      <Card className="card rounded-2xl shadow-md">
        <CardHeader className="p-4 pb-0">
          <h3 className="text-slate-800 font-semibold">{t('help.request.title') || 'Submit Request / Ask for Help'}</h3>
        </CardHeader>
        <CardContent className="p-4 space-y-3">
          <textarea value={helpText} onChange={(e)=>setHelpText(e.target.value)} className="w-full min-h-32 px-3 py-2 border rounded" placeholder={t('help.request.placeholder') || 'Describe your issue or request...'} />
          <div className="flex items-center gap-3">
            <label className="inline-flex items-center gap-2 px-4 py-2 rounded-lg font-medium bg-white border border-gray-300 cursor-pointer">
              <Upload className="h-4 w-4" />
              <input type="file" className="hidden" onChange={(e)=> setHelpFile(e.target.files?.[0] || null)} />
              <span>{helpFile?.name || (t('help.request.attach') || 'Attach file')}</span>
            </label>
            <Button color="primary" onClick={submitHelpRequest} disabled={loading}>
              <Send /> {t('help.request.submit') || 'Submit'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default Help

